import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: "40%",
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    marginTop: 70,
    left: "30%",
  },
  fullWidth: {
    width: "100%",
  },
}));

export default function SimpleModal({
  meetingMode,
  createMeeting,
  startMeeting,
  handleClose,
}) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);

  //   return <div>test</div>;

  const body = (
    <div className={classes.paper} style={{padding:"30px"}}>
      <h8 id="simple-modal-title">
        Confirmer{" "}
        {meetingMode === "createMeeting" ? "la création" : "le démarrage"} de la
        visioconférence ?
      </h8>
      <br /> <br />
      <div className="row">
        <div className="col-6">
          <button
            className={`btn btn-primary ${classes.fullWidth}`}
            onClick={() => {
              if (meetingMode === "createMeeting") {
                createMeeting(meetingMode);
              } else {
                startMeeting(meetingMode);
              }
            }}
          >
            OK
          </button>
        </div>
        <div className="col-6">
          <button
            className={`btn btn-light ${classes.fullWidth}`}
            onClick={handleClose}
          >
            Annuler
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </div>
  );
}
